import React, { useState } from 'react';
import PropTypes from 'prop-types';
import cssModule from 'react-css-modules';
import { connect } from 'react-redux';

import { useKeyCount } from 'hooks/index';
import Event from 'newDesign/modules/live/components/bettingSuggestions/Event';
import {
  getBSConfig,
  getBSProcessingEvent,
  getBSVisibility,
} from 'reducers';

import style from 'newDesign/modules/live/components/bettingSuggestions/BettingSuggestions.scss';

const mapStateToProps = state => ({
  processingEvent: getBSProcessingEvent(state),
  show: getBSVisibility(state),
  hasBSConfig: getBSConfig(state),
});

const BettingSuggestions = ({
  matchId, processingEvent, show, hasBSConfig,
}) => {
  const [hasOdds, setHasOdds] = useState(false);
  const [usedMarket, setUsedMarket] = useState({});
  const [usedMarket2, setUsedMarket2] = useState({});
  const count = useKeyCount('b');
  const keyToggle = (count % 2 !== 0);

  return (
    <div
      styleName='bettingSuggestions'
      style={{
        display: (keyToggle && hasOdds && hasBSConfig) || (show && hasOdds && hasBSConfig) ? 'flex' : 'none',
      }}
    >
      {
        (keyToggle || show) && (
          <Event
            processingEvent={processingEvent}
            matchId={matchId}
            setHasOdds={setHasOdds}
            setUsedMarket={setUsedMarket}
            tempUsedMarket={usedMarket}
            setUsedMarket2={setUsedMarket2}
            tempUsedMarket2={usedMarket2}
            maxMarkets={16}
          />
        )
      }
    </div>
  );
};

BettingSuggestions.propTypes = {
  matchId: PropTypes.number,
  processingEvent: PropTypes.object,
  show: PropTypes.bool,
  hasBSConfig: PropTypes.bool,
};

BettingSuggestions.defaultProps = {
  matchId: 0,
  processingEvent: null,
  show: false,
  hasBSConfig: false,
};

const BettingSuggestionsStyled = cssModule(BettingSuggestions, style);
export default connect(
  mapStateToProps,
)(BettingSuggestionsStyled);
